import React, { useEffect, useState, useRef, useContext } from 'react';
import { Redirect, useHistory } from 'react-router-dom';
import { useForm, Controller } from 'react-hook-form';
import InputMask from 'react-input-mask';
import CurrencyInput from 'react-currency-input';
import { URLBunge } from "./Componentes/Config";
import { LogAcesso, AlertForm, AlertRedirect, MascaraCNPJ } from "./Componentes/Funcoes";
import CabecalhoPagina from "./Componentes/Cabecalho";
import Carregando from "./Componentes/Carregando";
import MenuPrinc from "./Componentes/MenuPrinc";

import {
  Clear,
  BackgroundImg,
  TitNoticias,
  ColunaRegras,
  TextoDescPesquisa,
  FormPesquisa,
  DoisCampos,
  CampoFormBusca,
  CampoFormCadastro,
  BotaoEnviarPesquisa,
  BtIcoBuscar,
  DescCampo,
  ModalEvento,
  BgModal,
  ItemListaBusca,
  ClienteProdutoSelecionado,
  BtVoltar
} from './Estilos'

import IcoBusca from './Images/ico_search_branco.png'
import ImgBtSetaVoltar from "./Images/BtSeta.png";

function PesquisaExtra(props) {

  const history = useHistory();
  const [ Loading, setLoading ] = useState(false);
  const { register, handleSubmit, errors, control, setValue } = useForm();

  const [ NomeEvento, setNomeEvento ] = useState("Minha Bunge Vendas");
  const [ Token, setToken ] = useState(localStorage.getItem("c_token"));
  const [ IdUser, setIdUser ] = useState(localStorage.getItem("id_tb_user"));
  const [ CPFUser, setCPFUser ] = useState(localStorage.getItem("c_cpf"));

  useEffect(() => {
    if (Token === null) {
        history.push({ pathname: '/', state: {} });
    } else {
        LogAcesso(Token, "Pesquisa Extra")
    }
  }, []);


  const myinput = useRef();

  const [ PrecoPao, setPrecoPao ] = useState(0);
  const [ ClienteSelecionado, setClienteSelecionado ] = useState(false);
  const [ TextoAguarde, setTextoAguarde ] = useState(false);

  const onSubmit = async (data, e) => {  

    if(ClienteSelecionado == null || ClienteSelecionado == ''){
      AlertForm('Você precisa selecionar um cliente');
      e.preventDefault();
      return false
    } 

    if(PrecoPao == null || PrecoPao == ''){
      AlertForm('Você deve informar o preço do KG do pão do cliente.');
      e.preventDefault();
      return false
    }
    
    setTextoAguarde(true);

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "bearer " + Token);
    myHeaders.append("Content-Type", "application/json");
    
    var raw = JSON.stringify({
      "lojaId": ClienteID,
      "precoUnitario": PrecoPao
    });
    
    var requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: raw,
      redirect: 'follow'
    };
    
    fetch(`${URLBunge}/api/Pesquisa/SalvaExtra`, requestOptions)
      .then(response => response.json())
      .then(result => {
        console.log(result)
        if(result.sucesso === true) {
          setTextoAguarde(false);
          AlertForm('Sua pesquisa foi cadastrada com sucesso!');
          setPrecoPao(0)
          setValue('c_razaosap', '')
          setClienteNome('');
          setClienteCPNJ('');
          setClienteSAP('');
          setClienteID('');
          setClienteSelecionado(false);

        } else {
          setTextoAguarde(false);
          AlertForm(result.mensagem);
        }      
      })
      .catch(error => console.log('error', error));

  };


  const [ClienteMostra, setClienteMostra] = useState(false);
  const [DadosClienteFlatlist, setDadosClienteFlatlist] = useState([]);

  const BuscaCliente = async (data, e) => { 
      
    // console.log(data);

    if(data.c_razaosap == undefined || data.c_razaosap.length < 5) {
      AlertForm('Você precisa digitar no mínimo 5 dígitos');
      e.preventDefault();
      return false
    }

    setClienteMostra(true);
    
    var myHeaders = new Headers();
    myHeaders.append("Authorization", "bearer " + Token);

    var requestOptions = {
    method: 'GET',
    headers: myHeaders,
    redirect: 'follow'
    };

    fetch(`${URLBunge}/api/Pesquisa/ListarRazaoSap/`+ CPFUser +"/"+data.c_razaosap, requestOptions)
    .then(response => response.json())
    .then(result => {
        console.log(result);
        setCarregandoBusca(false);
        if(result.outEntidades.length > 0) {
        setDadosClienteFlatlist(result.outEntidades);
        }
    })
    .catch(error => console.log('error', error));

  }

  const [CarregandoBusca, setCarregandoBusca] = useState(true);
  function LoadBusca() {
    return <>
    <div>Carregando...</div>
    </>
  }

  const [ClienteNome, setClienteNome] = useState("");
  const [ClienteCPNJ, setClienteCPNJ] = useState("");
  const [ClienteSAP, setClienteSAP] = useState("");
  const [ClienteID, setClienteID] = useState("");

  function SelecionaCliente(ClienteNome, ClienteCPNJ, ClienteSAP, ClienteID) {
    setClienteMostra(false);
    setCarregandoBusca(true);
    setDadosClienteFlatlist([]);
    setClienteNome(ClienteNome);
    setClienteCPNJ(ClienteCPNJ);
    setClienteSAP(ClienteSAP);
    setClienteID(ClienteID);
    setClienteSelecionado(true);
    setValue('c_razaosap', '')
  }

  function FecharBuscaCliente() {
    setClienteMostra(false);
    setCarregandoBusca(true);
    setDadosClienteFlatlist([]);
  }

  const renderItem = ( item, index ) => (
    <ItemListaBusca key={index} onClick={()=>SelecionaCliente(item.nome, item.cnpj, item.sap, item.id)}>
        <div className={'NomeCliente'}>{item.nome}</div>
        <div className={'CNPJSAP'}><span>CPNJ</span> {MascaraCNPJ(item.cnpj)}</div>
        <div className={'CNPJSAP'}><span>SAP</span> {item.sap}</div>
    </ItemListaBusca>
  );

  function MostraBuscaCliente(props) {
    return <>
        <BgModal>
        <ModalEvento>
            <div className={'TituloEvento'}>Busca de clientes</div><Clear />
            <div className={'ListaClientes'} style={{textAlign: 'left'}}>
                <>                    
                    {CarregandoBusca == true ?
                    <LoadBusca />
                    :
                    DadosClienteFlatlist.length > 0 ?
                        DadosClienteFlatlist.map((item, index) => {
                            return renderItem(item, index)
                        })
                    :
                    <div>Nenhum cliente encontrado{'\n'}Verifique sua busca e tente novamente.</div>
                    }
                </>
            </div>
            <a className={'BtFecharModal'} onClick={()=>FecharBuscaCliente()}>FECHAR</a>
        </ModalEvento>
        </BgModal>
    </>
  }


  return (
    <>  
        <CabecalhoPagina NomeEvento={NomeEvento} />
        {Loading === true ? <Carregando /> : null }

        <BackgroundImg Background={''} BackgroundMob={''} bgcolor={'#FFFFFF'}>
        {/* <BackgroundImg Background={BgRegras} BackgroundMob={BgRegras} bgcolor={'#3c647d'}> */}

            { ClienteMostra == true ? <MostraBuscaCliente /> : null }
            
            <ColunaRegras>
                <div className={'AreaColunaRegras'}>

                    <TitNoticias>Pesquisa Extra</TitNoticias>
                    <Clear />

                    <TextoDescPesquisa>Formulário para pesquisa de preços.</TextoDescPesquisa>
                    <Clear />


                  <BtVoltar onClick={()=>history.push({ pathname: '/home', state: { } })} style={{marginLeft: 'auto', marginRight: 'auto'}}>
                    <img src={ImgBtSetaVoltar} /> <div>VOLTAR</div>
                  </BtVoltar>

                    <FormPesquisa onSubmit={handleSubmit(onSubmit)}>

                        <DescCampo>Dados do cliente</DescCampo>
                        {ClienteSelecionado == false ? 
                            <CampoFormBusca>
                                <Controller
                                    control={control}
                                    ref={register}
                                    id="c_razaosap"
                                    name="c_razaosap"
                                    type="text"
                                    placeholder={'Razão social ou SAP'}
                                    className="CampoForm CampoFormLogin"
                                    as={InputMask}
                                    mask=""
                                />
                                <BtIcoBuscar onClick={handleSubmit(BuscaCliente)}><img src={IcoBusca} /></BtIcoBuscar>
                            </CampoFormBusca>
                        :
                            <ClienteProdutoSelecionado>
                                <div className={'NomeCliente'}>{ClienteNome}</div>
                                <div className={'CNPJSAP'}><span>CPNJ</span> {MascaraCNPJ(ClienteCPNJ)}</div>
                                <div className={'CNPJSAP'}><span>SAP</span> {ClienteSAP}</div>
                                <div className={'BtAlterar'} onClick={()=>setClienteSelecionado(false)}>ALTERAR</div>
                            </ClienteProdutoSelecionado>
                        }

                        <DescCampo>Qual o preço do KG do Pão do cliente?</DescCampo>
                        <CampoFormCadastro>
                            <CurrencyInput
                                id="c_preco"
                                name="c_preco"
                                prefix="R$ "
                                decimalSeparator=","
                                thousandSeparator="."
                                maxlength="10"
                                value={PrecoPao}
                                onChange={(_, valor) => setPrecoPao(valor)}
                            />
                        </CampoFormCadastro>
                        
                        { TextoAguarde === false ?
                            <BotaoEnviarPesquisa type="submit">ENVIAR PESQUISA</BotaoEnviarPesquisa>
                        :
                            <BotaoEnviarPesquisa disabled>AGUARDE...</BotaoEnviarPesquisa>
                        }

                        <Clear />


                        </FormPesquisa>



                    
                </div>  
            </ColunaRegras>
            
            <MenuPrinc Pagina="Pesquisas" />
         </BackgroundImg>
    </>
  );

}

export default PesquisaExtra;
